import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { Card, Footer, LanguageSelector, Loading } from '@reveni-io/reveni-ui'

import AppContext from '@/context/AppContext'

import PortalMerchantHeader from './PortalMerchantHeader/PortalMerchantHeader'
import { getAllowedLanguages } from './helpers'
import * as Styles from './styles'

const PortalLayout = ({ loading, descriptionText, onChangeLanguage, children, headerAboveCard = false }) => {
  const { context } = useContext(AppContext)
  const { i18n } = useTranslation()
  const { merchantInfo } = context

  return (
    <Styles.Layout
      headerAboveCard={headerAboveCard}
      background={merchantInfo?.theme?.returns_background_url}
      backgroundMobile={merchantInfo?.theme?.returns_background_mobile_url}
      hasCover={merchantInfo?.theme?.returns_cover_url}
    >
      <Loading show={loading}>
        {headerAboveCard && (
          <Styles.HeaderContainer>
            <PortalMerchantHeader merchantInfo={merchantInfo} descriptionText={descriptionText} />
          </Styles.HeaderContainer>
        )}
        <Card
          header={
            headerAboveCard ? null : (
              <PortalMerchantHeader merchantInfo={merchantInfo} descriptionText={descriptionText} insideCard />
            )
          }
          footer={
            <Footer partnerLogo={merchantInfo?.theme?.partner_logo_url} partnerUrl={merchantInfo?.theme?.partner_url} />
          }
        >
          {children}
        </Card>
        <Styles.LanguageSelectorContainer>
          <LanguageSelector
            onChange={onChangeLanguage}
            selectedLanguage={i18n.language}
            languages={getAllowedLanguages(merchantInfo?.supported_languages)}
          />
        </Styles.LanguageSelectorContainer>
      </Loading>
    </Styles.Layout>
  )
}

export default PortalLayout
